<template>
  <div>
    <vs-card>
      <div slot="header">
        <h3>Filtrele</h3>
      </div>
      <vs-divider />
      <div>
        <b-row align-v="center">
          <b-col lg="3" sm="5">
            <b-form-input
              v-model="arananDeger"
              @keyup.enter="talepHavuzuList"
              id="smallInput"
              placeholder="Arama..."
            />
          </b-col>
          <b-col lg="3" sm="5">
            <v-select
              v-model="secilenDurum"
              :options="durumList"
              label="name"
              placeholder="Aktif"
              style=""
              @input="talepHavuzuList()"
            >
            </v-select>
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="talepHavuzuList"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              >{{ listtitle }}</vs-button
            >
          </b-col>
          <b-col lg="2" sm="5">
            <vs-button
              style="border-radius: 5px; width: 100%"
              type="gradient"
              @click="yeniStok"
              id="button-with-loading-yeni"
              class="vs-con-loading__container"
              color="danger"
              >{{ yenititle }}</vs-button
            >
          </b-col>
          <b-col lg="2">
            <vs-dropdown>
              <vs-button
                style="border-radius: 5px"
                class="btn-drop"
                type="gradient"
                color="#fc9551"
                gradient-color-secondary="rgb(255, 115, 0)"
                icon="expand_more"
                >Yeni İşlem</vs-button
              >

              <!-- <a href="#">Hola mundo</a> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="siparisOlustur">
                  Sipariş Oluştur
                </vs-dropdown-item>
                <vs-dropdown-item @click="teklifOlustur">
                  Teklif Oluştur
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </b-col>
        </b-row>
      </div>
    </vs-card>
    <vs-card>
      <ag-grid-vue
        style="width: 100%; height: 450px; margin-top: 25px"
        class="ag-theme-alpine"
        :defaultColDef="defaultColDef"
        :columnDefs="columnDefs"
        :rowData="rowData"
        :rowSelection="rowSelection"
        :localeText="localeText"
        :suppressAggFuncInHeader="true"
        :enableCellChangeFlash="true"
        :animateRows="true"
        @grid-ready="onGridReady"
        @selection-changed="onSelectionChanged"
        @first-data-rendered="onFirstDataRendered"
        @cell-value-changed="onCellValueChanged"
      >
      </ag-grid-vue>
    </vs-card>
    <SepetGuncelle ref="sepet" />
  </div>
</template>
<script>
import { BDropdown, BDropdownItem } from "bootstrap-vue";
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import vSelect from "vue-select";
import TalepHavuzuButon from "../components/crm-components/satinalma-components/TalepHavuzuButon.vue";
import SepetGuncelle from "../components/crm-components/stok-components/SepetGuncelle.vue";
import SepeteEkle from "../components/crm-components/stok-components/SepeteEkle.vue";
import CariAutosuggest from "../components/crm-components/satinalma-components/CariAutosuggest.vue";
import SatinalmaPlanlamaFiyatModal from "../components/crm-components/satinalma-components/SatinalmaPlanlamaFiyatModal.vue";
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";

import numericCellEditor from "./numericCellEditor";
export default {
  data() {
    return {
      danger: "danger",
      yenititle: "Yeni",
      size: "",
      listsize: "",
      listtitle: "Listele",
      durumList: [
        { name: "Aktif", val: 2 },
        { name: "Pasif", val: 3 },
        { name: "İptal", val: 4 },
      ],
      secilenDurum: "",
      arananDeger: "",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      localeText: null,
      columnDefs: null,
      rowData: null,
      rowSelection: null,
      secilenTalepler: [],
      editType: null,
      secilenGuncelSTOCKID: "",
      secilenGuncelRECEIPTID: "",
      secilenGuncelITEMNO: "",
      secilenGuncelQUANTITY: "",
      secilenGuncelPRICE: "",
      secilenGuncelTOTAL: "",
      secilenGuncelDESCRIPTION: "",
      secilenGuncelREQUIREDDATE: "",
      secilenGuncelACTID: "",
      fiyatlar: [],
    };
  },
  components: {
    ButtonPrimary,
    SatinalmaPlanlamaFiyatModal,
    CariAutosuggest,
    BDropdown,
    BDropdownItem,
    AgGridVue,
    TalepHavuzuButon,
    "v-select": vSelect,
    SepetGuncelle,
    SepeteEkle,
  },
  mounted() {
    this.talepHavuzuList();
    this.$root.$on("talepHavuzuList", () => {
      // your code goes here
      this.talepHavuzuList();
    });
  },
  methods: {
    onCellValueChanged(params) {
      try {
        const rowNode = this.gridApi.getDisplayedRowAtIndex(params.rowIndex);
        const colId = params.column.getId();
        if (colId === "PRICE") {
          params.data.PRICE = params.newValue;
          rowNode.setDataValue("IND1", Store.state.account.planlamaIND1);
          rowNode.setDataValue("IND2", Store.state.account.planlamaIND2);
          rowNode.setDataValue("IND3", Store.state.account.planlamaIND3);

          /*     if (typeof params.newValue.PRICE == "undefined") {
            console.log("undefined");
            params.data.PRICE = params.oldValue;
            //  rowNode.setDataValue("PRICE", params.oldValue);
          } else {
            rowNode.setDataValue("PRICE", params.newValue.PRICE);
            rowNode.setDataValue("IND1", params.newValue.IND1);
            rowNode.setDataValue("IND2", params.newValue.IND2);
            rowNode.setDataValue("IND3", params.newValue.IND3);
            params.data.PRICE = params.newValue.PRICE;
          }
          if (params.newValue == "") {
            rowNode.setDataValue("PRICE", params.oldValue);
          }*/
        } else if (colId === "IND1") {
          params.data.IND1 = params.newValue;
        } else if (colId === "IND2") {
          params.data.IND2 = params.newValue;
        } else if (colId === "IND3") {
          params.data.IND3 = params.newValue;
        } else if (colId === "ACTNAME") {
          params.data.cariAdi = params.newValue;
          params.data.ACTID = Store.state.account.planlamaCariId;
          console.log(params);
          /*    if (typeof params.newValue.ACTNAME != "undefined") {
            rowNode.setDataValue("ACTNAME", params.newValue.ACTNAME);
            params.data.ACTNAME = params.newValue.ACTNAME;
            params.data.ACTID = params.newValue.ACTID;
          }*/
        }
      } catch (error) {
        console.log(error);
      }
      //  this.$root.$emit("talepHavuzuList");
    },

    teklifOlustur() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenTalepler == 0) {
        vs.notify({
          title: "Satın alma",
          text: "Seçim yapınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        vm.secilenTalepler.forEach((val, index) => {
          var formatdate = moment(String(val.TRANSDATE)).format("DDMMYYYY");
          var formatreqdate = moment(String(val.REQUIREDDATE)).format(
            "DDMMYYYY"
          );
          const args = {
            token: Store.state.tokenId,

            TRANSTYPE: "213",
            TRANSCODE: formatreqdate, //ddMMYYYY
            ACTID: val.ACTID,
            EMPLOYEEID: Store.state.UserId,
            TARIH: val.TRANSDATE,
            STOCKID: val.STOCKID,
            DESCRIPTION: val.DESCRIPTION,
            ITEMNO: index + 1,
            QUANTITY: val.QUANTITY,
            PRICE: val.PRICE,
            TOTAL: val.PRICE * val.QUANTITY,
          };
          soap.createClient(url, function (err, client) {
            client.INT_Ins_Teklif(args, function (err, result) {
              if (result.INT_Ins_TeklifResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              try {
                vm.veriler = JSON.parse(result.INT_Ins_TeklifResult);
                vs.notify({
                  title: "Teklif",
                  text: "Teklif Eklendi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              } catch (error) {
                vs.notify({
                  title: "Teklif",
                  text: "Teklif Eklenirken Hata Oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        });
      }
    },
    siparisOlustur() {
      var vs = this.$vs;
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenTalepler.length == 0) {
        vs.notify({
          title: "Satın alma",
          text: "Seçim yapınız",
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
          position: "top-center",
        });
      } else {
        vm.secilenTalepler.forEach((val, index) => {
          var formatdate = moment(String(val.TRANSDATE)).format("DDMMYYYY");
          var formatreqdate = moment(String(val.REQUIREDDATE)).format(
            "DDMMYYYY"
          );
          const args = {
            token: Store.state.tokenId,

            TRANSTYPE: "203",
            TRANSCODE: formatreqdate, //ddMMYYYY
            ACTID: val.ACTID,
            EMPLOYEEID: Store.state.UserId,
            TARIH: val.TRANSDATE,
            STOCKID: val.STOCKID,
            DESCRIPTION: val.DESCRIPTION,
            ITEMNO: index + 1,
            QUANTITY: val.QUANTITY,
            PRICE: val.PRICE,
            TOTAL: val.PRICE * val.QUANTITY,
          };
          soap.createClient(url, function (err, client) {
            client.INT_Ins_Orders(args, function (err, result) {
              if (result.INT_Ins_OrdersResult == "-1") {
                Store.dispatch("logout");
                //this.$store.dispatch('login', payload)
              }
              try {
                vm.veriler = JSON.parse(result.INT_Ins_OrdersResult);
                console.log(vm.veriler)
                vs.notify({
                  title: "Sipariş",
                  text: "Sipariş Eklendi",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "success",
                  position: "top-center",
                });
              } catch (error) {
                vs.notify({
                  title: "Sipariş",
                  text: "Sipariş Eklenirken Hata Oluştu",
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "danger",
                  position: "top-center",
                });
              }
            });
          });
        });
      }
    },
    yeniStok() {
      this.$refs.sepet.sepetGuncelle();
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onSelectionChanged() {
      // this.$store.commit("account/SATINALMA_TUR", this.tur);
      console.log("onSelectionChanged");
      var selectedRows = this.gridApi.getSelectedRows();
      this.secilenTalepler = selectedRows;
      this.$store.commit("account/SATINALMA_CARI", "");
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },
    detayList() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
    },
    talepHavuzuList() {
      var vm = this;
      var vs = this.$vs;
      vs.loading({
        background: "#0064fa",
        color: "#fff",
        container: "#button-with-loading-yeni",
        scale: 0.45,
      });
      var secilend = vm.secilenDurum.val;
      if (typeof vm.secilenDurum.val == "undefined") secilend = "2";
      const soap = require("soap");
      const url = state.sistemAddress;
      if (vm.secilenSatis != "" && vm.secilenTermin != "") {
        const args = {
          token: Store.state.tokenId,
          ARANAN: vm.arananDeger,
          STATUS: secilend,
        };
        soap.createClient(url, function (err, client) {
          client.INT_Ls_SalTalepHavuzu(args, function (err, result) {
            if (result.INT_Ls_SalTalepHavuzuResult == "-1") {
              Store.dispatch("logout");
              //this.$store.dispatch('login', payload)
            }
            try {
              vm.veriler = JSON.parse(result.INT_Ls_SalTalepHavuzuResult);
              if (vm.veriler.response == "Ok") {
                vm.rowData = JSON.parse(vm.veriler.jsonData);
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              } else {
                vs.notify({
                  title: "Uyarı",
                  text: vm.veriler.message,
                  iconPack: "feather",
                  icon: "icon-alert-circle",
                  color: "warning",
                  position: "top-center",
                });
                vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
              }
            } catch (error) {
              vs.notify({
                title: "Hata",
                text: "Liste getirilirken hata oluştu.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "danger",
                position: "top-center",
              });
              vs.loading.close("#button-with-loading-yeni > .con-vs-loading");
            }
          });
        });
      }
    },
  },

  created() {
    this.editType = "fullRow";
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "multiple";
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 350,
        field: "",
        cellRendererFramework: "TalepHavuzuButon",
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        editable: false,
      },

      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        valueFormatter: this.parseDate,
        editable: false,
      },
      {
        headerName: "Fiş No",
        sortable: true,
        filter: "agTextColumnFilter",
        field: "RECEIPTNO",
        editable: false,
      },
      {
        headerName: "Sıra No",
        field: "ITEMNO",
        sortable: true,
        editable: false,
        filter: "agNumberColumnFilter",
      },
      {
        headerName: "Stok No",
        field: "STOCKNO",
        sortable: true,
        editable: false,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Stok Adı",
        field: "STOCKNAME",
        sortable: true,
        editable: false,
        filter: "agTextColumnFilter",
      },
      {
        headerName: "Miktar",
        field: "QUANTITY",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
      },
      {
        headerName: "Fiyat",
        field: "PRICE",
        sortable: true,
        filter: "agNumberColumnFilter",
        cellEditor: "agSelectCellEditor",
        editable: true,
        cellEditorPopup: true,
        cellEditorSelector: (params) => {
          return {
            component: "SatinalmaPlanlamaFiyatModal",
            popup: true,
          };
        },
      },
      {
        headerName: "İskonto 1",
        field: "IND1",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true,
      },
      {
        headerName: "İskonto 2",
        field: "IND2",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true,
      },
      {
        headerName: "İskonto 3",
        field: "IND3",
        sortable: true,
        filter: "agNumberColumnFilter",
        editable: true,
        filter: true,
      },
      {
        headerName: "İstenen Tarih",
        field: "REQUIREDDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        valueFormatter: this.parseDate,
        editable: false,
      },
      {
        headerName: "Açıklama",
        field: "DESCRIPTION",
        sortable: true,
        filter: "agTextColumnFilter",
        cellEditor: "agTextCellEditor",
        /*   cellEditorPopup: true,
        cellEditorParams: {
          maxLength: 100,
          rows: 10,
          cols: 50,
        },*/
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        filter: "agTextColumnFilter",
        filter: true,
        editable: true,
        cellEditorPopup: true,
        cellEditorSelector: (params) => {
          return {
            component: "CariAutosuggest",
            popup: true,
          };
        },
      },
    ];
  },
};
</script>
<style lang="scss">
.vs-dropdown--item .vs-dropdown--item-link {
  text-decoration-line: blink;
}
[dir="ltr"] .btn-group :not(:last-child) {
  border-top-right-radius: 3;
  border-bottom-right-radius: 3;
 // padding-top: 5px !important;
}
table.vgt-table {
  font-size: small;
}
.autocomplete {
  position: relative;
  display: inline-block;
}

input {
  border: 1px solid transparent;
  background-color: #f1f1f1;
  padding: 10px;
  font-size: 16px;
}

input[type="text"] {
  background-color: #f1f1f1;
  width: 100%;
}

input[type="submit"] {
  background-color: DodgerBlue;
  color: #fff;
  cursor: pointer;
}

.autocomplete-items {
  position: absolute;
  border: 1px solid #d4d4d4;
  border-bottom: none;
  border-top: none;
  z-index: 99;
  /*position the autocomplete items to be the same width as the container:*/
  top: 100%;
  left: 0;
  right: 0;
}

.autocomplete-items div {
  padding: 10px;
  cursor: pointer;
  background-color: #fff;
  border-bottom: 1px solid #d4d4d4;
}

/*when hovering an item:*/
.autocomplete-items div:hover {
  background-color: #e9e9e9;
}

/*when navigating through the items using the arrow keys:*/
.autocomplete-active {
  background-color: DodgerBlue !important;
  color: #ffffff;
}
</style>